import script from "./DownloadPlatformSelectionPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./DownloadPlatformSelectionPopup.vue?vue&type=script&setup=true&lang=ts"

import "./DownloadPlatformSelectionPopup.vue?vue&type=style&index=0&id=40582850&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40582850"]])

export default __exports__